import clsx from 'clsx'
import { Ref } from 'react'

import { SwiperButtonNext } from './assets/swiper-button-next'
import { SwiperButtonPrev } from './assets/swiper-button-prev'

import cl from './style.module.scss'

export interface SwiperArrowsProps {
	prevElRef: Ref<HTMLButtonElement>
	nextElRef: Ref<HTMLButtonElement>
	className?: string
}

export const SwiperArrows = (props: SwiperArrowsProps) => {
	const { prevElRef, nextElRef, className = '' } = props
	const rootClass = clsx(cl.btns, className)
	return (
		<div className={rootClass}>
			<button ref={prevElRef} className={clsx(cl.btn, cl.btn_prev)}>
				<SwiperButtonPrev />
			</button>
			<button ref={nextElRef} className={clsx(cl.btn, cl.btn_next)}>
				<SwiperButtonNext />
			</button>
		</div>
	)
}
